/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'AccountSafetyIndex',
    path: '/account-safety/index',
    component: () =>
      import(
        /* webpackChunkName: "AccountSafetyIndex" */ '@/views/account-safety/index'
      ),
    meta: { title: '账号与安全' },
  },
  {
    name: 'cancelAccount',
    path: '/account-safety/cancel-account',
    component: () =>
      import(
        /* webpackChunkName: "cancelAccount" */ '@/views/account-safety/cancel-account/index'
      ),
    meta: { title: '注销账号' },
  },
  {
    name: 'cancelAccountSmsCode',
    path: '/account-safety/sms-code',
    component: () =>
      import(
        /* webpackChunkName: "cancelAccountSmsCode" */ '@/views/account-safety/sms-code/index'
      ),
    meta: { title: ' ' },
  },
];
